import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';
import startCase from 'lodash/startCase';
import { useTranslation } from 'react-i18next';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormGlobalSetting from '../../forms/FormGlobalSetting.jsx';

const PageSetting = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();
  const { t } = useTranslation();

  useEffect(() => {
    req({
      url: `/api/site/setting`,
    });
  }, [_id]);

  return (
    <PageHttp res={res}>
      {(doc) => (
        <>
          <Header>
            {t('Global Setting')}
          </Header>
          <FormGlobalSetting setting={doc} />
        </>
      )}
    </PageHttp>
  );
};

export default PageSetting;
